class MaBePersonalisation extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener('change', () => this.update(), options);
    this.addEventListener('click', event => {
      const preview = event.target.closest('[data-preview-image]');
      const dialog = this.querySelector('dialog');
      if (preview) { this.querySelector('[data-dialog-image]').src = preview.dataset.image; dialog.showModal(); }
      if (event.target.closest('[data-close-dialog]') || event.target === dialog) dialog.close();
    }, options);
    this.update();
  }
  disconnectedCallback() { this.abort?.abort(); if (this.previewUrl) URL.revokeObjectURL(this.previewUrl); }
  update() {
    const selected = this.querySelector('input[type=radio]:checked');
    for (const item of this.querySelectorAll('[data-addon-item]')) {
      const active = item.contains(selected);
      item.querySelector('[data-addon-details]').hidden = !active;
      const option = item.querySelector('select').selectedOptions[0];
      const preview = item.querySelector('[data-preview-image]');
      preview.hidden = !option?.dataset.image;
      if (option?.dataset.image) { preview.dataset.image = option.dataset.image; preview.querySelector('img').src = option.dataset.image; }
    }
    const engraving = this.querySelector('mabe-engraving-preview');
    if (engraving) {
      engraving.hidden = !selected?.value;
      engraving.querySelector('input').disabled = !selected?.value;
      if (!engraving.hidden) engraving.draw?.();
    }
    const requiresUpload = selected?.dataset.requiresUpload === 'true';
    this.querySelector('[data-upload]').hidden = !requiresUpload;
    const file = this.querySelector('[data-upload-file]').files[0];
    const preview = this.querySelector('[data-upload-preview]');
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    preview.hidden = !requiresUpload || !file || !file.type.startsWith('image/') || /heic/i.test(file.type);
    if (!preview.hidden) { this.previewUrl = URL.createObjectURL(file); preview.src = this.previewUrl; }
    this.querySelector('[data-addon-error]').hidden = true;
  }
  selection() {
    const selected = this.querySelector('input[type=radio]:checked');
    if (!selected?.value) return null;
    const option = selected.closest('[data-addon-item]').querySelector('select').selectedOptions[0];
    if (!option || option.disabled) throw new Error('Diese Zusatzoption ist ausverkauft.');
    const file = this.querySelector('[data-upload-file]').files[0];
    const requiresUpload = selected.dataset.requiresUpload === 'true';
    if (requiresUpload && !file?.size) throw new Error('Bitte wähle erst eine Bilddatei für deine Gravur aus.');
    if (requiresUpload && file && !file.type.startsWith('image/') && !/\.heic$/i.test(file.name)) throw new Error('Bitte wähle eine Bilddatei.');
    return { id: option.value, title: selected.dataset.title + (option.dataset.title === 'Default Title' ? '' : ' — ' + option.dataset.title), parentTitle: this.dataset.parentTitle, requiresUpload, file };
  }
  showError(message) { const error = this.querySelector('[data-addon-error]'); error.textContent = message; error.hidden = false; error.focus(); }
}
if (!customElements.get('mabe-personalisation')) customElements.define('mabe-personalisation', MaBePersonalisation);
